var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.Mtype==1)?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/static/img/wx_link.png"}}):_vm._e(),_vm._v(" "),(_vm.Mtype==2)?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/static/img/wx_ios.png"}}):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/static/img/wx_foot.png","alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0abb2e45","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/download.vue
// module id = null
// module chunks = 